'use client';

/**
 * AddPaymentMethodSkeleton
 *
 * Generic loading skeleton for the add payment method screen. Used while
 * gateway config is loading (PurchaseFlow and PaymentSourcesFlow). Keeps
 * a simple placeholder layout rather than mimicking a specific form.
 */

import React from 'react';
import classes from './classes.module.scss';

export const AddPaymentMethodSkeleton: React.FC = () => (
  <div className={ classes.addPaymentMethodSkeleton } aria-hidden="true">
    <div className={ classes.addPaymentMethodSkeletonLine } />
    <div className={ classes.addPaymentMethodSkeletonLine } />
    <div className={ classes.addPaymentMethodSkeletonLine } />
    <div className={ classes.addPaymentMethodSkeletonLine } />
    <div className={ classes.addPaymentMethodSkeletonButton } />
  </div>
);
